import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const LogoStyled = styled('img')({
  minHeight: '15%',
  maxHeight: '20%',
  objectFit: 'contain',
});

export const BackgroundSidebarStyled = styled('div')(({ theme }) => ({
  width: 350,
  height: 300,
  backgroundColor: theme.palette.global.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const InputStyled = styled('input')({
  height: 32,
  width: 200,
  borderRadius: 3,
  border: '1px solid #cccccccc',
  '& + input': {
    marginTop: 20,
    marginBottom: 20,
  },
});

export const CreateAccountStyled = styled('p')({
  fontSize: 12,
  fontWeight: 'bold',
});
